import { getKompisSettingsApplicationName } from '../../services/kompisSettings';
import { getLanguage, getParsedLocale } from '../../utils/i18nUtils';
import { getKioskId, isKiosk, isProduction } from '../../utils/platform';
import { getStoreId } from '../../utils/queryUtils';
import { PlatformEnum } from '@insights/insights-data-provider';
export const getInsightsAppConnectData = ({ abTestExperiment, applicationVersion }) => {
    const parsedLocale = getParsedLocale();
    const countryCode = parsedLocale.countryCode.toLowerCase(); // needs to be lower case or else INGKAs google analytics script can't map country code to UA-tracking id
    const languageCode = getLanguage();
    const kiosk = isKiosk();
    const storeId = kiosk ? getStoreId() || undefined : undefined;
    const kioskId = kiosk ? getKioskId() || undefined : undefined;
    const applicationId = getKompisSettingsApplicationName();
    const dev = !isProduction();
    return {
        applicationId,
        applicationVersion,
        platform: PlatformEnum.owfe,
        countryCode,
        languageCode,
        kiosk,
        storeId,
        kioskId,
        dev,
        isPlanner: true,
        abVersionName: abTestExperiment?.name,
        abVersionVariation: abTestExperiment?.variation
    };
};
//# sourceMappingURL=getConnectInsightsData.js.map